export default __webpack_public_path__ + "static/media/close.61c47a65.svg";